import Container from '@anm/components/Container';
import TitleBlock from '@anm/components/TitleBlock';
import { flexCenter, flexRow } from '@anm/styles/helpers';
import styled from 'styled-components';

export const Title = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
  }
`;

export const CategoriesList = styled.div`
  ${flexRow};
  flex-wrap: wrap;
  margin-top: 31px;
`;

export const CategoryItem = styled.div`
  ${flexCenter};
  color: #292a2b;
  padding: 0 30px;
  font-size: 16px;
  min-height: 50px;
  font-weight: 700;
  border-radius: 5px;
  background: #f5f7fa;
  margin: 0 10px 10px 0;
  transition: background 300ms ease-in;
  &:hover {
    background: #ebeef5;
  }
`;

export const RowWrapper = styled.div`
  margin-top: 60px;
`;

export const ContainerWrapper = styled(Container)`
  margin-bottom: 100px;
`;
